const IMAGE_TYPE = ['jpg', 'png', 'jpeg', 'webp', 'jfif', 'apng', 'avif', 'gif', 'svg'];
const VIDEO_TYPE = ['mp4', 'webm'];
const AUDIO_TYPE = ['mp3', 'wav', 'ogg'];

const handleFormatFile = (file: string | null | undefined): 'audio' | 'video' | 'image' | 'file' => {
	if (!file) return 'file';

	const type = file?.split('?')?.[0]?.split('.')?.pop()?.toLowerCase() ?? null;

	if (!type) return 'file';

	if (IMAGE_TYPE.includes(type)) return 'image';
	if (VIDEO_TYPE.includes(type)) return 'video';
	if (AUDIO_TYPE.includes(type)) return 'audio';

	return 'file';
};

export default handleFormatFile;
